module.exports = __webpack_public_path__ + "01_glasses_brown.d89d8edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer4/01_glasses_brown.png
// module id = KCQU
// module chunks = 0